import { callable } from '../callable';

// La página Alumnos (graduation_audit): academicsDispatch → listStudents.

export type StudentStatusDto = 'graduated' | 'active' | 'inactive';

export interface StudentRowDto {
  personId: string;
  studentCode: string | null;
  firstName: string;
  lastName: string;
  status: StudentStatusDto;
  deceasedInSource: boolean;
  programs: string[];
  lastTermName: string | null;
}

export type StudentCountsDto = Record<StudentStatusDto, number> & { total: number };

export interface StudentsListDto {
  today: string;
  currentTerm: { id: string; name: string } | null;
  rows: StudentRowDto[];
  counts: { all: StudentCountsDto; withoutDeceased: StudentCountsDto };
}

export const studentsApi = {
  list: async (data: { tenantId: string }): Promise<StudentsListDto> => {
    const fn = callable<typeof data, StudentsListDto>('listStudents');
    return (await fn(data)).data;
  },
};
